package com.arenaproplay.admin.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText
import com.arenaproplay.admin.navigation.Routes
import com.arenaproplay.admin.state.auth.LocalAuthSession
import com.arenaproplay.admin.ui.theme.AppColors
import com.arenaproplay.admin.ui.theme.toHexString
import com.arenaproplay.admin.ui.theme.bodySMedium
import org.jetbrains.compose.web.css.*

@Page("/")
@Composable
fun HomePage() {
    val ctx = rememberPageContext()
    val session = LocalAuthSession.current

    LaunchedEffect(Unit) {
        if (session.isAuthenticated && session.isAdmin) {
            ctx.router.navigateTo(Routes.ANALYTICS)
        } else {
            ctx.router.navigateTo(Routes.LOGIN)
        }
    }

    // Minimal loading flash — background + centered spinner dot
    Box(
        Modifier
            .fillMaxSize()
            .backgroundColor(AppColors.Background),
        contentAlignment = Alignment.Center
    ) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            // Pulsing brand dot
            Box(
                Modifier
                    .width(8.px)
                    .height(8.px)
                    .borderRadius(50.percent)
                    .styleModifier {
                        property("background", "#${AppColors.Primary.toHexString()}")
                        property("opacity", "0.6")
                        property("animation", "arena-pulse 1.2s ease-in-out infinite")
                    }
            )
            Box(Modifier.height(12.px))
            SpanText(
                "Загрузка…",
                Modifier.bodySMedium().color(AppColors.Faint)
            )
        }
    }
}
